const APP_ENV = (process.env.REACT_APP_ENV || 'local').trim().toLowerCase();

const normalizeApiBaseUrl = (value) => {
  const trimmed = (value || '').trim();
  if (trimmed.startsWith('/')) return trimmed.replace(/\/+$/, '');
  const url = trimmed.replace(/\/+$|\/api\/*$/i, '');
  return `${url}/api`;
};

const defaultEnvConfig = {
  local: {
    name: 'local',
    apiBaseUrl: '/api',
    frontendUrl: 'http://localhost:3000',
  },
  development: {
    name: 'development',
    apiBaseUrl: 'https://mme-website.onrender.com/api',
    frontendUrl: 'https://mme-website-gamma.vercel.app',
  },
  production: {
    name: 'production',
    apiBaseUrl: 'https://api.makemyexpert.com/api',
    frontendUrl: 'https://www.makemyexpert.com',
  },
};

const envConfig = defaultEnvConfig[APP_ENV] || defaultEnvConfig.local;

const apiBaseUrl = normalizeApiBaseUrl(process.env.REACT_APP_API_URL || envConfig.apiBaseUrl);
const frontendUrl = (process.env.REACT_APP_FRONTEND_URL || envConfig.frontendUrl).trim().replace(/\/+$/, '');

export default {
  env: APP_ENV,
  isLocal: APP_ENV === 'local',
  isDevelopment: APP_ENV === 'development',
  isProduction: APP_ENV === 'production',
  ...envConfig,
  apiBaseUrl,
  frontendUrl,
};